<div class="annual-hero-bg">
    <section class="annual-hero-section container">
        <div class="glass-panel-container">
            <div class="row align-items-center w-100 m-0"> <!-- Added w-100 m-0 to fix row overflow -->
                <div class="col-lg-6 hero-content-col">
                    <h1 class="banner-heading-one">In The Spotlight</h1>
                    <p class="hero-subtitle">Discover the fresh stories of Kalpita Technologies.</p>
                </div>
                <div class="col-lg-6 hero-image-col text-center">
                    <img src="../../../../assets/resources/news-main/sixthanniversary-bannerimg.png"
                        alt="Anniversary Illustration" class="img-fluid hero-image"> <!-- Added img-fluid -->
                </div>
            </div>
        </div>
    </section>
</div>

<!-- Anniversary Content Section -->
<div class="anniversary-content-section">
    <div class="container">
        <!-- Main Title -->
        <div class="row">
            <div class="col-12 text-center">
                <h2 class="section-title">Kalpita Technologies Celebrates 6 Years of Innovation</h2>
            </div>
        </div>

        <!-- Large Feature Image -->
        <div class="row justify-content-center my-4 my-md-5">
            <div class="col-md-10 grid-image">
                <img src="../../../../assets/resources/news-main/spotlight-grids.jpg" alt="kalpita sixth anniversary"
                    class="img-fluid rounded-4 shadow-lg">
            </div>
        </div>

        <!-- Description Text -->
        <div class="row justify-content-center">
            <div class="col-md-10 text-center">
                <p class="section-description">
                    Explore our 6th anniversary highlights, published across 40 renowned platforms. This emphasizes our
                    accomplishments, milestones, and our commitment to innovation and customer satisfaction.
                </p>
            </div>
        </div>

        <!-- Grid of News Logos -->
        <div class="logo-grid-container mt-5">
            <!-- Added g-4 for consistent gutter spacing -->
            <div class="row g-4"> 
                <div class="col-lg-3 col-md-4 col-sm-6 d-flex align-items-stretch" *ngFor="let item of displayedItems">
                    <div class="logo-card">
                        <img [src]="item.url" alt="{{ item.alttext }}" class="ico-product">
                        <p class="mt-auto w-100"> <!-- mt-auto pushes link to bottom -->
                            <a class="ellipsis-link" target="_blank" [href]="item.link" [title]="item.link">
                                {{ item.link }}
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <!-- 'Expand More' button -->
        <div class="text-center" *ngIf="showExpandMore()">
            <button class="load-more-btn" (click)="loadMore()">
                Expand More <i class="ri-arrow-down-s-line"></i>
            </button>
        </div>
    </div>
</div>

<!-- Relevant Article -->
<app-relevant-newsarticle></app-relevant-newsarticle>